/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:30abea17-9777-48de-bb58-8003471cc5b7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_9wjZKqVO9",
    "aws_user_pools_web_client_id": "29qdlui7h6julomak7gkjves12",
    "oauth": {}
};


export default awsmobile;
